// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"51e7fc9e","885":"3977cef0","977":"02722cfc"}[chunkId] + ".chunk.js";
};